module.exports = __webpack_public_path__ + "static/media/bolt.3c58af30.svg";